import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { environment as config } from '../../../environments/environment';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { BasicService } from '../../providers/basic';
import { TranslateService } from '@ngx-translate/core';
import { ITag } from '../../models/tag';
import * as isColor from 'is-color';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { omit } from 'ramda';
import { Subject } from 'rxjs';
import { eva_constants } from '../../eva_constants';

@Injectable()
export class CustomizationService extends BasicService {
  private API = config.sessions.url;
  private TAGS_API = config.tags.url;
  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }
  public onAccountTagStateChange$: Subject<ITag> = new Subject();

  public getCustomizableFields(session: ISession, modelType: string) {
    return this.http
      .get(`${this.TAGS_API}/tags/${session.id}?language=${session.language}`)
      .map(res => {
        return this.extractData(res, false);
      })
      .catch(err => this.handleError(err));
  }

  public updateTags(session: ISession, tags: ITag[]) {
    return this.http
      .put(
        `${this.TAGS_API}/sessions/${session.id}/tags?language=${session.language}`,
        tags.map(tag => this.removeMarkerInTag(tag))
      )
      .map(res => this.extractData(res, false))
      .catch(err => this.handleError(err));
  }

  public uploadImage(session: ISession, tag: ITag, image: string) {
    return this.http
      .put(`${this.TAGS_API}/tags/${session.id}/image?language=${session.language}`, {
        tag
      })
      .map(res => this.extractData(res, false));
  }

  public uploadFile(session: ISession, value, data) {
    return this.http
      .put(
        `${this.TAGS_API}/tags/${session.id}/file`,
        {
          value,
          data
        },
        { headers: this.apiTokenHeaders() }
      )
      .map(res => this.extractData(res, false));
  }

  public updateFilename(session: ISession, value) {
    return this.http
      .patch(
        `${this.TAGS_API}/tags/${session.id}/file`,
        {
          value
        },
        { headers: this.apiTokenHeaders() }
      )
      .map(res => this.extractData(res, false));
  }

  public removeFile(session: ISession, value) {
    return this.http
      .delete(`${this.TAGS_API}/tags/${session.id}/file/${value.id}`, {
        headers: this.apiTokenHeaders()
      })
      .map(res => this.extractData(res, false));
  }

  public removeImage(session: ISession, tag: ITag, notify: boolean = true) {
    return this.http
      .patch(`${this.TAGS_API}/tags/${session.id}/image?language=${session.language}`, {
        tag
      })
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public getTags(session: ISession) {
    return this.http
      .get(`${this.TAGS_API}/tags/${session.id}/display?language=${session.language}`)
      .map(res => this.extractData(res, false))
      .map((tags: any[]) => {
        return tags.map(tag => {
          const description = tag.description || '';
          return Object.assign(tag, {
            tag: `(!--ct:${tag.name}--)`,
            description: description.slice(description.lastIndexOf('--') + 2)
          });
        });
      });
  }

  public getAccountTag(tag: String) {
    return this.http
      .get(`${this.TAGS_API}/tags/name/${tag}`)
      .map(res => this.extractData(res, false))
      .map((tag: any) => {
        const description = tag.description || '';
        return Object.assign(tag, {
          tag: `(!--ct:${tag.name}--)`,
          description: description.slice(description.lastIndexOf('--') + 2)
        });
      })
      .catch(err => {
        console.log(err);
        return Observable.of(null);
      });
  }

  // Quick-Fix: need to refactor this part in the tag-editor module
  private removeMarkerInTag(tag: ITag): ITag {
    if (tag.type === 'json') {
      return tag;
    }
    const div = document.createElement('div');
    div.innerHTML = tag.value;
    const markers = [].slice.call(div.querySelectorAll('.rangySelectionBoundary'));
    return Object.assign(tag, {
      value: markers.reduce((result: string, marker: any) => {
        return result.replace(marker.outerHTML, '');
      }, div.innerHTML)
    });
  }

  private apiTokenHeaders(): Headers {
    const headers = new Headers();
    headers.append('X-Api-Token', AuthService.retrieve(AuthService.API_TOKEN_KEY));
    return headers;
  }

  public updateAccountTag(tag: ITag, language: string) {
    return this.http
      .put(
        `${this.TAGS_API}/tags/account/update?language=${language}`,
        omit(['tag'], this.removeMarkerInTag(tag))
      )
      .map(res => this.extractData(res, false))
      .do(tagRes => {
        if (tag.name === eva_constants.ACCOUNT_DISPLAYNAME_TAG && tagRes) {
          this.onAccountTagStateChange$.next(tagRes[0]);
        }
      })
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customization/customization.service.ts